<template>
  <card-modal :visible="true" :title="title">
    <div id="modal-edit-content" class="content coach-modal" v-bind:class="[showPreview ? 'is-hidden' : '']">
      
      <div class="columns">
        <div class="column is-half">
          <label class="label">Nome [PT]</label>
          <p class="control">
            <input class="input" type="text" placeholder="Nome do Coche" v-model="coach.name.pt">
          </p>
        </div>
        <div class="column is-half">
          <label class="label">Nome [EN]</label>
          <p class="control">
            <input class="input" type="text" placeholder="Nome do Coche" v-model="coach.name.en">
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <label class="label">Nome [ES]</label>
          <p class="control">
            <input class="input" type="text" placeholder="Nome do Coche" v-model="coach.name.es">
          </p>
        </div>
        <div class="column is-half">
          <label class="label">Nome [FR]</label>
          <p class="control">
            <input class="input" type="text" placeholder="Nome do Coche" v-model="coach.name.fr">
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor de Fundo</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="coach.background_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextBackground === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('background')"
            >{{ colorPickerBtnTextBackground }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input coach-color-preview" type="text" v-bind:style="{ backgroundColor: coach.background_color.hex }" disabled>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor de Titulo + Texto do Menu</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="coach.title_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextTitle === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('title')"
            >{{ colorPickerBtnTextTitle }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input coach-color-preview" type="text" v-bind:style="{ backgroundColor: coach.title_color.hex }" disabled>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor Botões Inactivos</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="coach.inactive_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextInactive === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('inactive')"
            >{{ colorPickerBtnTextInactive }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input coach-color-preview" type="text" v-bind:style="{ backgroundColor: coach.inactive_color.hex }" disabled>
        </div>
      </div>  
      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor Botões Activos</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="coach.active_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextActive === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('active')"
            >{{ colorPickerBtnTextActive }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input coach-color-preview" type="text" v-bind:style="{ backgroundColor: coach.active_color.hex }" disabled>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor de Separadores do Menu</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="coach.filet_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextFilet === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('filet')"
            >{{ colorPickerBtnTextFilet }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input coach-color-preview" type="text" v-bind:style="{ backgroundColor: coach.filet_color.hex }" disabled>
        </div>
      </div>

      <sketch-picker v-show="showColorPicker" 
                     v-model="pickerColor"
                     @input="onChangePickerColor"
                     :class="'color-picker-position-' + colorPickerPosition"
      ></sketch-picker>

      <div class="columns">
        <div class="column is-half">
          <label class="label">Background <span class="font-weight-light">(1920x1080px)</span></label>
          <figure v-if="!newBackground && coach.background_image" 
                  class="image is-16by9 coach-image fake-dropzone" 
          >
            <img :src="coach.background_image">
            <a class="dz-remove" @click="showDropzone('background')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="coachBackgroundDz"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadBackground"
                      v-on:vdropzone-removedfile="removeBackground"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
        <div class="column is-half">
          <label class="label">Foreground <span class="font-weight-light">(1920x1080px)</span></label>
          <figure v-if="!newForeground && coach.foreground_image" 
                  class="image is-16by9 coach-image fake-dropzone"
          >
            <img :src="coach.foreground_image">
            <a class="dz-remove" @click="showDropzone('foreground')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="coachForegroundDz"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadForeground"
                      v-on:vdropzone-removedfile="removeForeground"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
      </div>
    </div>
    <div id="modal-preview-content" class="content" v-bind:class="[showPreview ? '' : 'is-hidden']">
      <p class="control">
        <span class="select">
          <select v-model="previewLanguage">
            <option value="pt">PT</option>
            <option value="en">EN</option>
            <option value="es">ES</option>
            <option value="fr">FR</option>
          </select>
        </span>
      </p>

      <div class="coach-preview-image" onresize="handleResize">
        <figure id="coach-image-preview-container" class="image" v-bind:style="{ backgroundColor: coach.background_color.hex }"> 
          <image-composite :background="coach.background_image" 
                           :foreground="coach.foreground_image"
                           :showLogo="true"
                           :logoColor="backgroundLightness"
          ></image-composite>
        </figure>
      </div>

      <div v-if="previewText"
           class="preview-coach-name" 
           v-bind:style="{ color: coach.title_color.hex, transform: textZoom, left: leftScale }"
      >{{ previewText }}</div>
      
      <div class="circle-container" v-bind:style="{ transform: textZoom }">
        <div class="circle circle-home"
             v-bind:style="previewActiveStyle"
        ><span class="mnc mnc-MncApplicationFont_home"></span></div>
        <div class="circle"
             v-bind:style="[isSelectedLanguage('pt') ? previewActiveStyle : previewInactiveStyle]"
        ><span class="mnc mnc-MncApplicationFont_pt"></span></div>
        <div class="circle"
             v-bind:style="[isSelectedLanguage('en') ? previewActiveStyle : previewInactiveStyle]"
        ><span class="mnc mnc-MncApplicationFont_en"></span></div>
        <div class="circle"
             v-bind:style="[isSelectedLanguage('fr') ? previewActiveStyle : previewInactiveStyle]"
        ><span class="mnc mnc-MncApplicationFont_fr"></span></div>
        <div class="circle"
             v-bind:style="[isSelectedLanguage('es') ? previewActiveStyle : previewInactiveStyle]"
        ><span class="mnc mnc-MncApplicationFont_es"></span></div>
      </div>

      <div class="menu-container" v-bind:style="{ transform: textZoom }">
        <div class="filet" 
             v-bind:style="{ background: coach.filet_color.hex }"></div>
        <div class="menu-btn-container">
          <div class="menu-btn-text"
               v-bind:style="{ color: coach.title_color.hex }"
          >TEXTO MENU</div>
          <div class="circle" v-bind:style="previewInactiveStyle">
            <span class="mnc mnc-MncApplicationFont_forward"></span>
          </div>
        </div>
        <div class="filet" 
             v-bind:style="{ background: coach.filet_color.hex }"></div>
      </div>

      <div class="preview-coach-name-warning">
        <span class="preview-warning-text"><b>Aviso:</b> {{ previewWarning }}</span>
      </div>
    </div>
  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'
import Sketch from '../Util/Picker/ColorPicker'
import Dropzone from '../Util/DropzoneForm'
import { WHITE_COLOR, API_ROOT, COACH_IMG_PATH } from '../../config'
import ImageComposite from '../Util/ImageComposite'
import tinycolor from 'tinycolor2'

function setColor (data, oldHue) {
  var color = data.hex ? tinycolor(data.hex) : tinycolor(data)
  var hsl = color.toHsl()
  var hsv = color.toHsv()
  if (hsl.s === 0) {
    hsl.h = data.h || oldHue || 0
    hsv.h = data.h || oldHue || 0
  }
  return {
    hsl: hsl,
    hex: color.toHexString().toUpperCase(),
    rgba: color.toRgb(),
    hsv: hsv,
    a: 1
  }
}

const DESKTOP_MIN_WIDTH = 769
const MAX_PREVIEW_SIZE_MOBILE = 671
const DEFAULT_PREVIEW_SIZE = 600

export default {
  components: {
    CardModal,
    'sketch-picker': Sketch,
    Dropzone,
    ImageComposite
  },

  props: {
    title: String,
    coachData: Object
  },

  data () {
    return {
      pickerColor: WHITE_COLOR,
      showColorPicker: false,
      currentColorPicker: 'background',
      colorPickerPosition: 1,
      colorPickerBtnTextBackground: 'Selecionar Cor',
      colorPickerBtnTextTitle: 'Selecionar Cor',
      colorPickerBtnTextFilet: 'Selecionar Cor',
      colorPickerBtnTextActive: 'Selecionar Cor',
      colorPickerBtnTextInactive: 'Selecionar Cor',
      showPreview: false,
      previewLanguage: 'pt',
      previewText: null,
      previewImageWidth: 600,
      previewWarning: 'Esta pré-visualização pode não ser uma representação fiel dos quiosques.',
      coach: {
        name: {
          pt: null,
          en: null,
          es: null,
          fr: null
        },
        background_color: WHITE_COLOR,
        title_color: WHITE_COLOR,
        filet_color: WHITE_COLOR,
        active_color: WHITE_COLOR,
        inactive_color: WHITE_COLOR,
        background_image: null,
        foreground_image: null,
        background_path: null,
        foreground_path: null
      },
      previewActiveStyle: {
        color: '#FFFFFF',
        background: '#FFFFFF',
        border: '1px solid #FFFFFF'
      },
      previewInactiveStyle: {
        color: '#FFFFFF',
        background: '#FFFFFF',
        border: '1px solid #FFFFFF'
      },
      newBackground: false,
      newForeground: false
    }
  },

  beforeDestroy () {
    let trash = document.body.querySelectorAll('.dz-hidden-input')
    for (let t of trash) {
      t.remove()
    }
  },

  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.handleResize)

      // force background color check on load
      if (this.coach.background_color) {
        document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-preview-btn').classList.add('is-disabled')
      }

      if (this.coachData) {
        this.coach.name.pt = this.coachData.languages[0].pivot.name
        this.coach.name.en = this.coachData.languages[1].pivot.name
        this.coach.name.es = this.coachData.languages[2].pivot.name
        this.coach.name.fr = this.coachData.languages[3].pivot.name

        this.coach.background_color = this.coachData.background_color ? setColor(this.coachData.background_color) : WHITE_COLOR
        this.coach.title_color = this.coachData.title_color ? setColor(this.coachData.title_color) : WHITE_COLOR
        this.coach.filet_color = this.coachData.filet_color ? setColor(this.coachData.filet_color) : WHITE_COLOR
        this.coach.active_color = this.coachData.active_color ? setColor(this.coachData.active_color) : WHITE_COLOR
        this.coach.inactive_color = this.coachData.inactive_color ? setColor(this.coachData.inactive_color) : WHITE_COLOR

        this.coach.background_image = this.coachData.background_path ? COACH_IMG_PATH + this.coachData.background_path : null
        this.coach.background_path = this.coachData.background_path
        this.coach.foreground_image = COACH_IMG_PATH + this.coachData.foreground_path
        this.coach.foreground_path = this.coachData.foreground_path
      }
    })
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },

    zoomScaleValue () {
      return this.previewImageWidth / DEFAULT_PREVIEW_SIZE
    },

    textZoom () {
      return 'scale(' + this.zoomScaleValue + ')'
    },

    leftScale () {
      return (88 * this.zoomScaleValue) + 'px'
    },

    submitIsActive () {
      return this.coach.name.pt &&
             this.coach.name.en &&
             this.coach.name.es &&
             this.coach.name.fr &&
             this.coach.foreground_image
    },

    previewIsActive () {
      return this.coach.background_color
    },

    userToken () {
      return window.store.state.auth.token
    },

    dropzoneUploadUrl () {
      return API_ROOT + 'resource/coach/upload?token=' + this.userToken
    },

    backgroundLightness () {
      return this.coach.background_color.hsl.l
    }
  },

  methods: {
    successUploadBackground (file) {
      this.coach.background_image = COACH_IMG_PATH + JSON.parse(file.xhr.response).file
      this.coach.background_path = JSON.parse(file.xhr.response).file

      this.newBackground = false
    },

    removeBackground () {
      console.log('A file was been removed')
      this.coach.background_image = null
      this.coach.background_path = null
    },

    successUploadForeground (file) {
      this.coach.foreground_image = COACH_IMG_PATH + JSON.parse(file.xhr.response).file
      this.coach.foreground_path = JSON.parse(file.xhr.response).file

      this.newForeground = false
    },

    removeForeground () {
      console.log('A file was been removed')
      this.coach.foreground_image = null
      this.coach.foreground_path = null
    },

    isSelectedLanguage (slug) {
      return slug === this.previewLanguage
    },

    onChangePickerColor (val) {
      switch (this.currentColorPicker) {
        case 'background':
          this.coach.background_color = val
          break
        case 'title':
          this.coach.title_color = val
          break
        case 'filet':
          this.coach.filet_color = val
          break
        case 'inactive':
          this.coach.inactive_color = val
          break
        case 'active':
          this.coach.active_color = val
          break
      }
    },

    handleResize () {
      if (this.showPreview) {
        let element = document.getElementById('coach-image-preview-container')
        if (element) {
          this.previewImageWidth = element.getBoundingClientRect().width
        }
      }
    },

    toogleColorPicker (selector) {
      if (selector === this.currentColorPicker || !this.showColorPicker) {
        this.showColorPicker = !this.showColorPicker
      }
      this.currentColorPicker = selector

      this.colorPickerBtnTextBackground = 'Selecionar Cor'
      this.colorPickerBtnTextTitle = 'Selecionar Cor'
      this.colorPickerBtnTextFilet = 'Selecionar Cor'
      this.colorPickerBtnTextInactive = 'Selecionar Cor'
      this.colorPickerBtnTextActive = 'Selecionar Cor'

      switch (selector) {
        case 'background':
          if (this.showColorPicker) {
            this.pickerColor = this.coach.background_color
            this.colorPickerBtnTextBackground = 'Fechar'
          }
          this.colorPickerPosition = 1
          break
        case 'title':
          if (this.showColorPicker) {
            this.pickerColor = this.coach.title_color
            this.colorPickerBtnTextTitle = 'Fechar'
          }
          this.colorPickerPosition = 2
          break
        case 'inactive':
          if (this.showColorPicker) {
            this.pickerColor = this.coach.inactive_color
            this.colorPickerBtnTextInactive = 'Fechar'
          }
          this.colorPickerPosition = 3
          break
        case 'active':
          if (this.showColorPicker) {
            this.pickerColor = this.coach.active_color
            this.colorPickerBtnTextActive = 'Fechar'
          }
          this.colorPickerPosition = 4
          break
        case 'filet':
          if (this.showColorPicker) {
            this.pickerColor = this.coach.filet_color
            this.colorPickerBtnTextFilet = 'Fechar'
          }
          this.colorPickerPosition = 5
          break
        default:
          this.showColorPicker = false
      }
    },

    showDropzone (selector) {
      if (selector === 'background') {
        this.newBackground = true
        this.removeBackground()
      }

      if (selector === 'foreground') {
        this.newForeground = true
        this.removeForeground()
      }
    }
  },

  watch: {
    currentEvent: function (val) {
      this.toogleColorPicker(null)

      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        if (this.coachData) {
          window.store.dispatch('updateCoach', { id: this.coachData.id, data: this.coach })
        } else {
          window.store.dispatch('saveCoach', this.coach)
        }
        // window.store.dispatch('newEvent', 'modal-card-close')
        // this.$destroy()
      }
      if (val === 'modal-card-preview') {
        if (!this.showPreview) {
          this.previewText = this.coach.name[this.previewLanguage]

          this.previewActiveStyle.color = this.coach.inactive_color.hex
          this.previewActiveStyle.background = this.coach.active_color.hex
          this.previewActiveStyle.border = '1px solid ' + this.coach.active_color.hex

          this.previewInactiveStyle.color = this.coach.active_color.hex
          this.previewInactiveStyle.background = this.coach.inactive_color.hex
          this.previewInactiveStyle.border = '1px solid ' + this.coach.active_color.hex
        }

        this.showPreview = !this.showPreview
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    },

    showPreview: function (val) {
      if (val && window.innerWidth < DESKTOP_MIN_WIDTH) {
        this.previewImageWidth = MAX_PREVIEW_SIZE_MOBILE - ((DESKTOP_MIN_WIDTH - 1) - window.innerWidth)
      }
    },

    submitIsActive: function (val) {
      if (document.querySelector('.card-modal-ok-btn')) {
        if (val) {
          document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled')
        } else {
          document.querySelector('.card-modal-ok-btn').classList.add('is-disabled')
        }
      }
    },

    previewIsActive: function (val) {
      if (document.querySelector('.card-modal-preview-btn')) {
        if (val) {
          document.querySelector('.card-modal-preview-btn').classList.remove('is-disabled')
        } else {
          document.querySelector('.card-modal-preview-btn').classList.add('is-disabled')
        }
      }
    },

    previewLanguage: function (val) {
      this.previewText = this.coach.name[val]
    }
  }
}
</script>

<style>
  @import url('~dropzone/dist/dropzone.css');
  @import 'https://fonts.googleapis.com/css?family=Roboto';

  .is-hidden {
    display: none !important;
  }

  .vue-color__sketch {
    position: absolute !important;
    top: 73px;
    right: 100px;
    z-index: 100;
  }

  .vue-color__sketch__hue-wrap {
    height: 24px !important;
  }

  .vue-color__c-hue__picker {
    height: 22px !important;
  }

  @media screen and (min-width: 769px) {
    .coach-color-preview {
      margin-top: 25px;
    }
  }

  .coach-modal .color-picker-position-1 {
    top: 166px !important;
  }

  .coach-modal .color-picker-position-2 {
    top: 243px !important;
  }

  .coach-modal .color-picker-position-3 {
    top: 320px !important;
  }

  .coach-modal .color-picker-position-4 {
    top: 397px !important;
  }

  .coach-modal .color-picker-position-5 {
    top: 474px !important;
  }

  #coachBackgroundDz,
  #coachForegroundDz {
    height: 165px;
    display: flex;
  }

  #coachBackgroundDz.dropzone .dz-preview .dz-error-message,
  #coachForegroundDz.dropzone .dz-preview .dz-error-message {
    top: 90px;
    left: 73px;
  }

  #coachBackgroundDz.dropzone .dz-message,
  #coachForegroundDz.dropzone .dz-message {
    margin: 4em auto;
  }

  .content #coachBackgroundDz a:not(.button):hover,
  .content #coachForegroundDz a:not(.button):hover {
    border-bottom-color: inherit;
  }

  .fake-dropzone {
    border: 1px solid #dbdbdb;
    border-radius: 3px;
  }

  .fake-dropzone .dz-remove {
    font-family: 'Roboto', sans-serif;
    color: #777;
    position: absolute;
    z-index: 30;
    color: white;
    margin-left: 15px;
    padding: 10px;
    top: inherit;
    bottom: 15px;
    border: 2px white solid;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
    text-align: center;
    display: block;
    cursor: pointer;
    background-color: rgba(37, 148, 139, 0.8);
  }

  .fake-dropzone:hover .dz-remove {
    opacity: 1;
  }

  .fake-dropzone a:not(.button) {
    border-bottom: 2px white solid !important;
  }

  .fake-dropzone a:not(.button):hover, .content #coachForegroundDz a:not(.button):hover {
    border-bottom-color: inherit !important;
  }

  .fa-coach-preview {
    font-size: 2.5em !important;
  }

  .fa-coach-preview .fa-circle {
    color: black !important;
  }

  .preview-coach-name {
    font-family: 'RongelExpert';
    font-size: 15.2pt;
    position: absolute;
    top: 136px;
    transform-origin: 0% 0%;
    width: 100%;
    max-width: 320px;
  }

  .preview-coach-name-warning {
    margin-top: 2px;
    transform-origin: 0% 0%;
  }

  .preview-warning-text {
    vertical-align: middle;
  }

  .circle-container {
    display: flex;
    position: absolute;
    top: 142px;
    right: 31px;
    transform-origin: top right;
  }

  .circle {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    border: 1px solid rgb(150, 0, 0);
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    position: relative;
    z-index: 1;
    margin-left: 6.7px;
  }

  .circle-home {
     margin-left: 0;
     margin-right: 50px;
  }

  .circle span {
    margin-left: 0.2px;
  }

  .circle-home span {
     margin-left: 0;
  }

  .menu-container {
    position: absolute;
    top: 181px;
    right: 31px;
    transform-origin: top right;
  }

  .filet {
    height: 1px;
    width: 176.875px;
  }

  .menu-btn-container {
    display: flex;
    align-items: center;
    padding: 16px 0;
  }

  .menu-btn-text {
    font-family: 'GothamRounded-Book';
    font-size: 9.375px;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// CoachEditModal.vue?72a457f0